module.exports = __webpack_public_path__ + "img/Frame-37.9297d458.svg";